/**
 * MuiChip
 *
 * Styles:
 *
 * - [Proto](https://www.figma.com/file/gImnv1p0uOIizS33dnZJa9/Patient-App-2.0?node-id=609%3A14930&mode=dev)
 */
const MuiChip = {
  styleOverrides: {
    // @ts-expect-error
    sizeLarge: ({
      theme
    }) => ({
      height: '40px',
      borderRadius: '20px',
      '& .MuiChip-label': {
        padding: theme.spacing(0, 2),
        fontSize: '16px'
      }
    }),
    colorPrimary: ({
      theme
    }) => ({
      outline: '1px solid',
      backgroundColor: theme.palette.grey[100]
    }),
    // @ts-expect-error MUI theme is not exposing this type but it's correct
    outlinedDefault: ({
      theme
    }) => ({
      '&.Mui-selected': {
        color: theme.palette.primary.main,
        borderColor: theme.palette.primary.main,
        outline: '1px solid',
        backgroundColor: theme.palette.grey[100]
      }
    })
  }
};
export default MuiChip;